<template>
  <div>
    <div class="vx-row">
      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Nome:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input
              v-uppercase
              v-validate="'required'"
              class="w-full"
              name="nome"
              v-model="usuario.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Telefone:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <telefone-input class="w-full" name="telefone" v-model="usuario.telefone" />
          </vs-col>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>E-mail:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input
              v-uppercase
              v-validate="'required'"
              class="w-full"
              name="email"
              v-model="usuario.email"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('email')"
            >{{ errors.first('email') }}</span>
          </vs-col>
        </div>
      </vs-col>
    </div>
    <div class="vx-row">
      <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Tipo de Usuário:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <tipo-usuario-select
              v-validate="'required'"
              name="usuario_tipo"
              v-model="usuario.usuarioTipo"
            ></tipo-usuario-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('usuario_tipo')"
            >{{ errors.first('usuario_tipo') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col
        v-if="todasAsAssociacoes && todasAsEntidades"
        vs-lg="4"
        vs-md="4"
        vs-sm="12"
        class="vx-col mb-4"
      >
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Associação:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <associacao-select
              v-validate="'required'"
              name="associacao"
              v-model="usuario.associacao"
            ></associacao-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('associacao')"
            >{{ errors.first('associacao') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col v-if="todasAsEntidades" vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Entidade:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <entidade-select
              v-validate="{ required: entideIsRequired }"
              name="entidade"
              v-model="usuario.entidade"
              :associacao="usuario.associacao"
              :clearable="true"
            ></entidade-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('entidade')"
            >{{ errors.first('entidade') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col v-if="todosOsParceiros" vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Parceiro:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <parceiro-select
              v-validate="{ required: parceiroIsRequired }"
              name="parceiro"
              v-model="usuario.parceiro"
              :associacao="usuario.associacao"
              :clearable="true"
            ></parceiro-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('parceiro')"
            >{{ errors.first('parceiro') }}</span>
          </vs-col>
        </div>
      </vs-col>
    </div>
  </div>
</template>

<script>
import TelefoneInput from "@/components/inputs/TelefoneInput.vue";
import AssociacaoSelect from "@/components/select/AssociacaoSelect.vue";
import TipoUsuarioSelect from "@/components/select/TipoUsuarioSelect.vue";
import EntidadeSelect from "@/components/select/EntidadeSelect.vue";
import ParceiroSelect from "@/components/select/ParceiroSelect.vue";

export default {
  name: "editar-dados-usuario",
  props: ["value"],
  components: {
    TelefoneInput,
    AssociacaoSelect,
    EntidadeSelect,
    ParceiroSelect,
    TipoUsuarioSelect
  },
  inject: ["$validator"],
  data() {
    return {
      usuario: {
        id: null
      },
      entideIsRequired: true,
      parceiroIsRequired: true
    };
  },
  created() {
    this.usuario = { ...this.value };
  },
  watch: {
    value(usuario, oldUsuario) {
      this.entideIsRequired =
        usuario.usuario_tipo_id == 4 || usuario.usuario_tipo_id == 5;
      this.parceiroIsRequired =
        usuario.usuario_tipo_id == 6 || usuario.usuario_tipo_id == 7;
      if (usuario.id !== oldUsuario.id) {
        this.usuario = usuario;
      }
    },
    usuario: {
      handler(usuario) {
        this.$emit("input", {
          id: usuario.id,
          nome: usuario.nome,
          telefone: usuario.telefone,
          email: usuario.email,
          usuarioTipo: usuario.usuarioTipo,
          usuario_tipo_id: usuario.usuarioTipo ? usuario.usuarioTipo.id : null,
          entidade: usuario.entidade,
          entidade_id: usuario.entidade ? usuario.entidade.id : null,
          associacao: usuario.associacao,
          associacao_id: usuario.associacao ? usuario.associacao.id : null,
          parceiro: usuario.parceiro,
          parceiro_id: usuario.parceiro ? usuario.parceiro.id : null
        });
      },
      deep: true
    }
  }
};
</script>



